export default {
    addToBoards: 'invite to the platform',
    addToList: 'add to the list',
    firmsCountSelectedPlural: {
        zero: '{{count}} companies selected',
        one: '{{count}} company selected',
        few: '{{count}} companies selected',
        many: '{{count}} companies selected',
        other: '{{count}} companies selected'
    },
    selectAllOnThePage: 'Select all on the page',
    addSelectedToBoards: 'Invite selected carriers to your platform'
};
